<script setup>
import ExplainDirective from '@/Pages/DomainAnalysis/Partials/ExplainDirective.vue';
import SPFDirectiveMessaging from '@/Common/Classifiers/SPFDirectiveMessaging.js';

defineProps({
  title: String,
  directive: Object
});
</script>

<template>
  <ExplainDirective
    :classifier="SPFDirectiveMessaging"
    :title="title"
    :directive="directive"
  />
</template>
